class UsersApiRequestModel {
  // #region Props
  activo;
  apellido1;
  apellido2;
  email;
  esAdministrador;
  esInterno;
  idGrupo;
  idUser;
  nombre;
  numInformes;
  rol;
  ultimoAcceso;
  unidad;
  // #endregion

  constructor(object) {
    // Assign props to this object instance
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        const element = object[key];
        this[key] = element;

        if (key == "idUser") {
          this.idUsuario = element;
        }
      }

      this.label = "";

      if (object["nombre"]) {
        this.label = object["nombre"];
      }

      if (object["apellido1"]) {
        this.label += " " + object["apellido1"];
      }

      if (object["apellido2"]) {
        this.label += " " + object["apellido2"];
      }
    }
  }

  // #region Private methods
  // #endregion
}

export default UsersApiRequestModel;
